import Axios from "axios"

export default {
  getIO(device) {
    return Axios.post(
      "/getIO",
      { deviceID: device },
      {
        headers: { Authorization: "Bearer " + localStorage.getItem("access_token") }
      }
    )
  },
  getApartmentAverage(device) {
    return Axios.post(
      "/getApartmentAverage",
      { deviceID: device },
      {
        headers: { Authorization: "Bearer " + localStorage.getItem("access_token") }
      }
    )
  },
  getSettings(device) {
    return Axios.post(
      "/getSettings",
      { deviceID: device },
      {
        headers: { Authorization: "Bearer " + localStorage.getItem("access_token") }
      }
    )
  },
  getOperationStatus(device) {
    return Axios.post(
      "/getOperationStatus",
      { deviceID: device },
      {
        headers: { Authorization: "Bearer " + localStorage.getItem("access_token") }
      }
    )
  },
  getZoneTemperatureHistory(zoneID, from, to) {
    return Axios.post(
      "/getZoneTemperatureHistory",
      {
        zoneID: zoneID,
        from: from,
        to: to
      },
      {
        headers: { Authorization: "Bearer " + localStorage.getItem("access_token") }
      }
    )
  },
  getZoneMode(zoneID, time) {
    return Axios.post(
      "/getZoneMode",
      {
        zoneID: zoneID,
        time: time
      },
      {
        headers: { Authorization: "Bearer " + localStorage.getItem("access_token") }
      }
    )
  },
  getZoneCompensatorSetting(zoneID, time) {
    return Axios.post(
      "/getZoneCompensatorSetting",
      {
        zoneID: zoneID,
        time: time
      },
      {
        headers: { Authorization: "Bearer " + localStorage.getItem("access_token") }
      }
    )
  },
  getZoneMonitorCurrentPositionHistory(zoneID, from, to) {
    return Axios.post(
      "/getZoneMotorCurrentPositionHistory",
      {
        zoneID: zoneID,
        from: from,
        to: to
      },
      {
        headers: { Authorization: "Bearer " + localStorage.getItem("access_token") }
      }
    )
  },
  getZonePressureBoilerHistory(zoneID, from, to) {
    return Axios.post(
      "/getZonePressureBoilerHistory",
      {
        zoneID: zoneID,
        from: from,
        to: to
      },
      {
        headers: { Authorization: "Bearer " + localStorage.getItem("access_token") }
      }
    )
  },
  getZoneMonitorTargetPositionHistory(zoneID, from, to) {
    return Axios.post(
      "/getZoneMotorTargetPositionHistory",
      {
        zoneID: zoneID,
        from: from,
        to: to
      },
      {
        headers: { Authorization: "Bearer " + localStorage.getItem("access_token") }
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/api/io.service.js